import { mapComponentTypesV2ToV1 } from 'util/misc'
import { activateComponentsIfNeeded } from './activateComponentsIfNeeded'

const clearSystemInverters = ({ systemUuid }: { systemUuid: string }) => {
  const system = systemUuid && window.editor.objectByUuid(systemUuid)
  const inverters = system?.inverters() || []
  var commandUUID = window.Utils.generateCommandUUIDOrUseGlobal()
  const mppts = inverters.flatMap((inverter) => inverter.mppts())

  // have to delete mppt first otherwise non-parent mppt throws error in react components
  mppts.forEach((component) => {
    window.editor.execute(new window.RemoveObjectCommand(component, true, false, commandUUID))
  })

  inverters.forEach((component) => {
    window.editor.execute(new window.RemoveObjectCommand(component, true, false, commandUUID))
  })
}

export async function loadInverterDesignAssistantResult(inverterSetIndex: number) {
  const system = window.editor?.selectedSystem
  if (!system) {
    throw new Error('No system selected. Please select a system in the design.')
  }

  // Find the message with the inverter recommendations
  const state = window.reduxStore?.getState()
  const messages = state?.chatDrawer?.messages || []

  let inverterSets: any[] = []
  for (let i = messages.length - 1; i >= 0; i--) {
    if (
      messages[i].direction === 'receive' &&
      messages[i].toolExecutionState &&
      messages[i].toolExecutionState.toolType === 'inverterDesignAssistant' &&
      messages[i].toolExecutionState.data?.inverterSets
    ) {
      inverterSets = messages[i].toolExecutionState.data.inverterSets
      break
    }
  }

  if (!inverterSets || inverterSets.length === 0) {
    throw new Error('No inverter recommendations found. Please run the inverter design assistant first.')
  }

  if (inverterSetIndex < 0 || inverterSetIndex >= inverterSets.length) {
    throw new Error(`Invalid inverter set index: ${inverterSetIndex}`)
  }

  const selectedInverterSet = inverterSets[inverterSetIndex]

  if (!selectedInverterSet.components || !selectedInverterSet.inverters_design_data) {
    throw new Error('Invalid inverter set data. Missing components or inverters_design_data.')
  }

  // Clear existing inverters
  clearSystemInverters({ systemUuid: system.uuid })

  await activateComponentsIfNeeded(selectedInverterSet.components, 'inverter')

  // Inject activated inverter id into inverter design data
  const invertersDesignData = selectedInverterSet.inverters_design_data.map((inverterData: any) => {
    const matchingComponent = selectedInverterSet.components.find((c: any) => c.code === inverterData.code)
    if (matchingComponent) {
      const activateComponentData = window.AccountHelper.getComponentActivationFromCode(
        matchingComponent.code,
        mapComponentTypesV2ToV1(matchingComponent.type || 'inverter')
      )
      return {
        ...inverterData,
        inverter_id: activateComponentData?.id || inverterData.inverter_id,
        inverter_activation_id: activateComponentData?.id || inverterData.inverter_activation_id,
      }
    }
    return inverterData
  })

  const systemDataForClusters = {
    inverters: invertersDesignData,
  }

  // Default for all selected inverters.
  const inverterExtraProps = {
    string_isolation: 'seperately',
  }

  // Build the system with the selected inverters
  // This will automatically handle activation and electrical components via SceneHelper
  window.SceneHelper.buildSystemForModuleClustersAndSystem(
    window.editor,
    system.uuid,
    systemDataForClusters,
    inverterExtraProps
  )

  console.log('Inverter design assistant result loaded')
}
